import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import DataLoader from 'dataloader';
import zipObject from 'lodash/zipObject';

/**
 * Creates a User ID Lookup.
 */
export function UserIdLookup(userAPI) {
  var privateIdsLoader = new DataLoader(_fetchPrivateIds, {
    cache: true
  });
  var publicIdsLoader = new DataLoader(_fetchPublicIds, {
    cache: true
  });
  return {
    lookupPrivateIds: lookupPrivateIds,
    lookupPublicIds: lookupPublicIds
  };
  function lookupPrivateIds(_x) {
    return _lookupPrivateIds.apply(this, arguments);
  }
  function _lookupPrivateIds() {
    _lookupPrivateIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(publicIds) {
      var validPublicIds, privateIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            validPublicIds = publicIds.filter(Boolean);
            _context.next = 3;
            return Promise.all(validPublicIds.map(function (id) {
              return privateIdsLoader.load(id);
            }));
          case 3:
            privateIds = _context.sent;
            return _context.abrupt("return", zipObject(validPublicIds, privateIds));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _lookupPrivateIds.apply(this, arguments);
  }
  function lookupPublicIds(_x2) {
    return _lookupPublicIds.apply(this, arguments);
  }
  function _lookupPublicIds() {
    _lookupPublicIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(privateIds) {
      var validPrivateIds, publicIds;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            validPrivateIds = privateIds.filter(Boolean);
            _context2.next = 3;
            return Promise.all(validPrivateIds.map(function (id) {
              return publicIdsLoader.load(id);
            }));
          case 3:
            publicIds = _context2.sent;
            return _context2.abrupt("return", zipObject(validPrivateIds, publicIds));
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _lookupPublicIds.apply(this, arguments);
  }
  function _fetchPrivateIds(_x3) {
    return _fetchPrivateIds2.apply(this, arguments);
  }
  function _fetchPrivateIds2() {
    _fetchPrivateIds2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(publicIds) {
      var result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return userAPI.lookupPrivateIds(publicIds.filter(Boolean));
          case 2:
            result = _context3.sent;
            return _context3.abrupt("return", publicIds.map(function (publicId) {
              return publicId ? result[publicId] : null;
            }));
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _fetchPrivateIds2.apply(this, arguments);
  }
  function _fetchPublicIds(_x4) {
    return _fetchPublicIds2.apply(this, arguments);
  }
  function _fetchPublicIds2() {
    _fetchPublicIds2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(privateIds) {
      var result;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return userAPI.lookupPublicIds(privateIds.filter(Boolean));
          case 2:
            result = _context4.sent;
            return _context4.abrupt("return", privateIds.map(function (privateId) {
              return privateId ? result[privateId] : null;
            }));
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _fetchPublicIds2.apply(this, arguments);
  }
}
//# sourceMappingURL=UserIdLookup.js.map
